export const myEducations = [
  {
    firstDate: "2024",
    secondDate: "2022",
    diplomaORexperience: "Digital Development — Full-Stack Track",
    location: "ISTA NTIC SYBA, Marrakech",
    decription:
      "Completed practical training in the MERN stack, REST APIs, relational and document databases, application architecture, and deployment fundamentals.",
  },
];

export const myExperiences = [
  {
    firstDate: "2024",
    secondDate: "Present",
    diplomaORexperience: "Full-Stack Developer & AI Integrator",
    location: "Freelance / Remote",
    decription:
      "Built and delivered 8+ web and mobile projects using React, Next.js, Node.js, Flutter, and MongoDB. Added Gemini and OpenAI features for assistants, analysis, content generation, and automated workflows, alongside Firebase, payments, and real-time product functionality.",
  },
];

export const skillCategories = [
  {
    category: "Web Frontend",
    skills: ["React", "Next.js", "TypeScript", "Tailwind CSS", "Redux", "Shadcn/UI"],
    level: 95,
  },
  {
    category: "Backend & Data",
    skills: ["Node.js", "Express", "MongoDB", "PostgreSQL", "Python", "REST APIs"],
    level: 92,
  },
  {
    category: "Applied AI",
    skills: ["Gemini API", "OpenAI", "LangChain", "Python", "Data Pipelines", "Auto-Gen"],
    level: 90,
  },
  {
    category: "Mobile & Delivery",
    skills: ["Flutter", "React Native", "Google Cloud", "Vercel", "Docker", "Firebase"],
    level: 85,
  },
];
